import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import styles from '../../../style.js';

class ShowGrid extends React.Component {

  render() {
    const { props } = this;

    return (
      <div>
      {props.data.length>0?
        <Box sx={{ width: '100%' }}>
          <Box sx={{ height: 400, mt: 1 }}>
            <DataGrid rows={props.data} columns={props.columns} getRowId={(row) =>  row.id} onRowClick={props.handleRowClick}
            pageSize={5} disableColumnMenu
            sx={{'& .MuiDataGrid-cell': styles.showGrid}}/>
          </Box>
        </Box>
        :
        <Alert className='customAlert' severity="info">       
          <div style={styles.alert}>Henüz bir süreciniz görünmüyor!</div>
          <div style={styles.alertDescription}>Süreç Şablonu Oluşturma, Yeni Süreç Başlatma veya Kayıtlı Süreç Başlatarak süreç ekleyebilir, tüm süreçlerinizi takip edebilir ve yönetebilirsiniz.</div>
        </Alert>}
      </div>
    );
  }
}

export default ShowGrid;
